"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const use_debounce_1 = require("use-debounce");
const react_2 = require("@ag-grid-community/react");
const client_side_row_model_1 = require("@ag-grid-community/client-side-row-model");
const range_selection_1 = require("@ag-grid-enterprise/range-selection");
const clipboard_1 = require("@ag-grid-enterprise/clipboard");
require("@ag-grid-community/core/dist/styles/ag-grid.css");
require("@ag-grid-community/core/dist/styles/ag-theme-balham.css");
const api_1 = require("../../api");
const errorNotification_1 = require("../../errorNotification");
const utils_1 = require("../utils");
const GridColumnTypes_1 = __importDefault(require("../Common/GridColumnTypes"));
const AuthContext_1 = require("../../Auth/AuthContext");
const quickOrderedFilter_1 = require("../quickOrderedFilter");
const gridUtils_1 = require("../gridUtils");
const Button_1 = __importDefault(require("../../forms/Button"));
const gridLocale_de_1 = __importDefault(require("../gridLocale.de"));
const OrderFullFillmentsColumns_1 = require("./OrderFullFillmentsColumns");
const Scanner_1 = __importDefault(require("./Scanner"));
const Toggle_1 = __importDefault(require("../Utils/Toggle"));
var quickFilterParsedValue = [];
const OrderFullFillmentsGrid = () => {
    const [gridApi, setGridApi] = (0, react_1.useState)(null);
    const [, setGridColumnApi] = (0, react_1.useState)(null);
    const [rows, setRows] = (0, react_1.useState)([]);
    const [columns, setColumns] = (0, react_1.useState)([]);
    const [newItemModalOpened, setNewItemModalOpened] = (0, react_1.useState)(false);
    const [isUserEditingGrid, setIsUserEditingGrid] = (0, react_1.useState)(false);
    const [remoteTransactionsQueue, setRemoteTransactionsQueue] = (0, react_1.useState)([]);
    const [quickFilterText, setQuickFilterText] = (0, react_1.useState)('');
    const [debouncedQuickFilterText] = (0, use_debounce_1.useDebounce)(quickFilterText, 300);
    const [catalogColumnKey, setCatalogColumnKey] = (0, react_1.useState)([]);
    const [formModalOpened, setFormModalOpened] = (0, react_1.useState)(true);
    const [current, setCurrent] = (0, react_1.useState)({ requested_quantity: 0 });
    const [showFilledEnabled, setShowFilledEnabled] = (0, react_1.useState)(false);
    const fillOrderApi = new api_1.OrderFullfillmentApi();
    const { user } = (0, AuthContext_1.useAuth)();
    (0, react_1.useEffect)(() => {
        quickFilterParsedValue = debouncedQuickFilterText ? debouncedQuickFilterText.toString().toLowerCase().split(' ') : [];
        if (gridApi)
            gridApi.onFilterChanged();
    }, [debouncedQuickFilterText]);
    const gridModules = [
        range_selection_1.RangeSelectionModule,
        client_side_row_model_1.ClientSideRowModelModule,
        clipboard_1.ClipboardModule,
    ];
    function onGridReady(params) {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        const fetchData = async () => {
            params.api.showLoadingOverlay();
            try {
                const data = await fillOrderApi.index({ show_filled: showFilledEnabled });
                params.api.setColumnDefs((0, OrderFullFillmentsColumns_1.OrderFullFillmentsColumns)());
                params.api.hideOverlay();
                params.api.showNoRowsOverlay();
                params.api.setRowData(data.items);
                if (data.items.length > 0) {
                    params.api.hideOverlay();
                }
            }
            catch (e) {
                if (e.response.status === 403) {
                    (0, errorNotification_1.notifyError)(e.response.data.message);
                }
                else {
                    (0, errorNotification_1.notifyError)(e.message);
                }
            }
            // params.api.hideOverlay();
        };
        fetchData().then(() => { });
    }
    const defaultColDef = {
        flex: 1,
        minWidth: 75,
        filter: true,
        resizable: true,
        sortable: true,
        floatingFilter: true,
        enablePivot: false,
        enableValue: false,
        enableRowGroup: false,
        cellClass: 'default',
    };
    const cellValueChanged = async (event) => {
        const { data } = event;
        const { newValue = null, oldValue = null } = event;
        if (newValue === oldValue) {
            return;
        }
        const isEditable = event.column.isCellEditable(event.node);
        if (isEditable) {
            const column = event.column.getColId();
            const { open_order_id, plant_option_id } = data;
            try {
                debouncedUpdate({ id: open_order_id, plant_option_id, filled_quantity: Number(event.node.data['filled_quantity']) });
            }
            catch (e) {
                (0, errorNotification_1.notifyError)(e.message);
            }
        }
    };
    const updateRecords = async (updates, apiG) => {
        try {
            const { success, changes } = await fillOrderApi.gridUpdate({ updates });
            const update = changes.map(change => {
                const rowNode = gridApi.getRowNode(change.id);
                const a = updates.find(o => o.id === change.id);
                for (const [column, value] of Object.entries(change)) {
                    // update only if changed
                    if (gridApi.getColumnDef(column) !== null && rowNode.data[column] != value) {
                        rowNode.setDataValue(column, value);
                    }
                }
            });
        }
        catch (error) {
            if (error.response && error.response.status > 200) {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
            else {
                (0, errorNotification_1.notifyError)(error.message);
            }
        }
    };
    const debouncedUpdate = (0, utils_1.debounceAgg)(updateRecords, 250);
    const doesExternalFilterPass = (node) => {
        return (0, quickOrderedFilter_1.quickOrderedFilter)((node.data['botanisch_slugged'] || '').split("-"), quickFilterParsedValue);
    };
    const isExternalFilterPresent = () => {
        return quickFilterParsedValue.length > 0;
    };
    const gridOptions = {
        enableRangeSelection: true,
        // defaultColDef: defaultColDef,
        getRowNodeId: (data) => {
            return data.plant_option_id;
        },
        isExternalFilterPresent: isExternalFilterPresent,
        doesExternalFilterPass: doesExternalFilterPass,
        excelStyles: [
            {
                id: 'default',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'derived',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'header',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            }
        ],
        //workaround for scanner event, that was messing the sorting order of focused header cell
        onSortChanged(event) {
            event.api.refreshHeader();
        }
    };
    const resetFilters = () => {
        gridApi.setFilterModel(null);
        setQuickFilterText('');
        gridApi.onFilterChanged();
    };
    const cellEditingStarted = (e) => {
        setIsUserEditingGrid(true);
    };
    const cellEditingStopped = (e) => {
        setIsUserEditingGrid(false);
    };
    const onShowFilledChange = async (value) => {
        setShowFilledEnabled(value);
        const data = await fillOrderApi.index({ show_filled: value });
        gridApi.setColumnDefs((0, OrderFullFillmentsColumns_1.OrderFullFillmentsColumns)());
        gridApi.hideOverlay();
        gridApi.showNoRowsOverlay();
        gridApi.setRowData(data.items);
        if (data.items.length > 0) {
            gridApi.hideOverlay();
        }
    };
    const gridTable = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_2.AgGridReact
        // @ts-ignore
        , { 
            // @ts-ignore
            modules: gridModules, localeText: gridLocale_de_1.default, disableStaticMarkup: true, onGridReady: onGridReady, 
            // onFirstDataRendered={onFirstDataRendered}
            onCellKeyDown: gridUtils_1.onCellKeyDown, onCellEditingStarted: cellEditingStarted, onCellEditingStopped: cellEditingStopped, rowSelection: 'multiple', suppressCopyRowsToClipboard: true, enableRangeSelection: true, undoRedoCellEditing: true, enableCellChangeFlash: true, animateRows: true, enableFillHandle: true, fillHandleDirection: 'y', gridOptions: gridOptions, columnDefs: columns, defaultColDef: defaultColDef, columnTypes: GridColumnTypes_1.default, rowData: rows, suppressLastEmptyLineOnPaste: true, getRowNodeId: (data) => data.open_order_id, onCellValueChanged: cellValueChanged, overlayNoRowsTemplate: '<span class="p-4 border-2 border-primary-400 bg-info">Keine offenen Bestellungen!</span>' }));
    }, [rows, columns, gridApi]);
    const handleScanUpdate = (updates) => {
        let toUpdate = updates.map(({ open_order_id, filled_quantity }) => {
            const rowNode = gridApi.getRowNode(open_order_id);
            // check if node exists
            if (rowNode) {
                return { ...rowNode.data, filled_quantity };
            }
            return null;
        }).filter(x => x); // filter nonexisting nodes (nulls)
        gridApi.applyTransaction({
            update: toUpdate,
        });
    };
    return (react_1.default.createElement("div", { className: "ag-theme-balham flex flex-col w-full flex-1" },
        react_1.default.createElement("div", { className: 'mb-2 flex items-end space-x-4' },
            react_1.default.createElement("div", { className: 'max-w-lg' },
                react_1.default.createElement("input", { type: "text", id: "filter-text-box", className: 'form-input', placeholder: "Suche nach botanischen Namen...", value: quickFilterText, onChange: e => setQuickFilterText(e.target.value) })),
            react_1.default.createElement("div", { className: 'space-x-2 flex flex-1' },
                react_1.default.createElement(Toggle_1.default, { enabled: showFilledEnabled, onToggle: onShowFilledChange, label: 'Abgeschlossene Positionen anzeigen' })),
            react_1.default.createElement("div", { className: 'space-x-1' },
                react_1.default.createElement(Button_1.default, { onClick: () => resetFilters(), size: 'sm', variant: 'white' }, "Filter zur\u00FCcksetzen")),
            react_1.default.createElement(Scanner_1.default, { handleScanUpdate: handleScanUpdate })),
        gridTable));
};
exports.default = OrderFullFillmentsGrid;
